import { render, staticRenderFns } from "./ModalProfile.vue?vue&type=template&id=ab80d920&scoped=true&"
import script from "./ModalProfile.vue?vue&type=script&lang=js&"
export * from "./ModalProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModalProfile.vue?vue&type=style&index=0&id=ab80d920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab80d920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab80d920')) {
      api.createRecord('ab80d920', component.options)
    } else {
      api.reload('ab80d920', component.options)
    }
    module.hot.accept("./ModalProfile.vue?vue&type=template&id=ab80d920&scoped=true&", function () {
      api.rerender('ab80d920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalProfile.vue"
export default component.exports